// latest: zhangmyh 2017-11-9 2:15 PM
// 模板库查询参照？参数type
import Collection from 'common/vo/collection'
import 'collection/ag_reject'
import { findIndex } from 'lodash'
import { Get } from 'common'
import './index.less'
/* global $ u ko */

let _config
let vm
let girdData

// 加载左侧树
let setTree = async function () {
  let data = await Get('/cpu-supplymgr/rejectCommon/getAllRejectCommonType')
  let data2 = []
  for (let i = 0; i < data.data.result.length; i++) {
    let x = {
      id: data.data.result[i].id,
      pid: data.data.result[i].parentId,
      title: data.data.result[i].title,
      open: false
    }
    data2.push(x)
  }
  vm.classTreemodel.removeAllRows()
  vm.classTreemodel.setSimpleData(data2)
}
// 供应分类点击事件
function zTreeOnClick (event, treeId, treeNode) {
  let setOrder = async function () {
    // 创建模板对象，初始化对应的值 tree
    await girdData.load({
      typeId: treeNode.id
    })
  }
  setOrder()
}
function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  girdData = Collection.create('ag_rejectList')
  // let tree = Collection.create('collection.qualifyclass')
  let selectedData = []
  let selectflag = false
  // tree.load({ parentId: _config.parentId })
  // 查询当前是否有模板
  setTree()
  vm = {
    searchKey: ko.observable(''),
    classTreemodel: new window.u.DataTable({
      meta: {
        'id': {
          'value': ''
        },
        'pid': {
          'value': ''
        },
        'title': {
          'value': ''
        }
      }
    }),
    treeOption: {
      view: {
        showLine: false,
        showIcon: false,
        selectedMulti: false,
        dblClickExpand: true,
      },
      data: {
        simpleData: {
          enable: true
        }
      },
      callback: {
        onClick: zTreeOnClick
      }
    },
    gridconfig: {
      id: 'gridtpl',
      data: girdData,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'typeName',
        'dataType': 'String',
        'title': '分类名称'
      }, {
        'field': 'content',
        'dataType': 'String',
        'title': '驳回原因'
      }, {
        'field': 'creatorName',
        'dataType': 'String',
        'title': '创建人'
      }, {
        'field': 'ts',
        'dataType': 'Date',
        'format': 'YYYY-MM-DD',
        'title': '创建时间'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#tpl_refer')[0])
  refer.registerSubmitFunc(() => {
    return selectedData
  })

  girdData.on('data', function (result) {
    selectflag = false
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      if (selectedData.length <= 0) {
        // 初始化默认值
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      result.data.result.forEach(function (listItem, i) {
        selectedData.forEach(function (item) {
          if (item.id === listItem.id) {
            SelectIndex.push(i)
          }
        })
      })
      girdData.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })

  girdData.datatable.on('unSelect', function (obj) {
    let selectData = girdData.datatable.getRowByRowId(obj.rowIds[0])
    // let isBasic = selectData.data.isBasic.value

    let index = findIndex(selectedData, ['id', selectData.data.id.value])
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })
  girdData.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = girdData.datatable.getCurrentRow().data
      selectedData = {
        id: selectData.id.value,
        content: selectData.content.value
      }
      // refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = girdData.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      let index = findIndex(selectedData, ['id', selectData.id.value])
      if (index >= 0) {
        return
      }
      selectedData.push({
        id: selectData.id.value,
        content: selectData.content.value
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false,
    type: 1
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/rejectSelect/index.js